/* eslint-disable no-console */
import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class CollectionReadMore extends ThemeComponent {

    @Ref({ required: false }) content!: HTMLElement;
    @Ref({ required: false }) toggleButton!: HTMLButtonElement;

    init() {

        if (!this.content || !this.toggleButton) {return;}

        this.checkOverflow();
        this.$listen(this.toggleButton, 'click', () => this.classList.toggle('collection-read-more--expanded'));
    }

    checkOverflow() {
        if (!this.content) {return;}

        const isOverflowing = this.content.scrollHeight > this.content.clientHeight;
        this.classList.toggle('collection-read-more--has-overflow', isOverflowing);
    }
}
